<template>
  <section>
    <div class="container">
      <div class="card">
        <div class="center">
          <h1>Recherches sauvegardées</h1>
          <span class="space20"></span>
          <br/>
  
          <b-table :data="savedParameters" paginated per-page="30" hoverable :opened-detailed="defaultOpenedDetails" detailed detail-key="id">
            <template slot-scope="props">
    <b-table-column field="id" label="ID" width="40" numeric>
      {{ props.row.id }}
    </b-table-column>
      <b-table-column field="email" label="Utilisateur" width="40" numeric>
      {{ props.row.email }}
    </b-table-column>
    <!-- <b-table-column field="name" label="Nom" sortable>
                  {{ props.row.name }}
                </b-table-column> -->
    <!-- <b-table-column field="brand" label="Marque" sortable>
      {{ props.row.brand_name }}
    </b-table-column> -->
    <b-table-column field="family" label="Famille" sortable>
      {{ props.row.family_name }}
    </b-table-column>
    <b-table-column label="Charger">
      <a :href="getUrl(props.row)">Charger</a>
    </b-table-column>
    <b-table-column label="Supprimer">
      <a class="has-text-danger" v-if="props.row.email == userEmail" v-on:click="deleteItem(props.row)">Supprimer</a>
    </b-table-column>
    <!-- <b-table-column field="libcaractlist" label="Has caracteristics" sortable>
                  {{ props.row.libcaractlist }}
                </b-table-column> -->
</template>

<template slot="detail" slot-scope="props">
  <article class="media">
    <figure class="media-left">
      <b-icon icon="information-outline" size="is-large" type="is-primary">
      </b-icon>
    </figure>
    <div class="media-content">
      <div class="content">
        <p>
          <strong>{{ props.row.family_name }} </strong>
           <br>
          <p>Liste des équipementiers:</p>
          <b-taglist>
             <b-tag v-for="brand in props.row.brands_label" :key="label" size="is-medium" type="is-info">{{brand}}</b-tag>
          </b-taglist>
          <small>Liste des attributs sélectionnés:</small>
          <br>
          <div v-if="props.row.labels">
          <b-taglist>
             <b-tag v-for="label in props.row.labels" :key="label" size="is-medium" type="is-info">{{label}}</b-tag>
          </b-taglist>

</div>

                  
                </p>
              </div>
            </div>
          </article>
        </template>
      </b-table>
          </div>
        </div>
    </div>

  </section>
</template>

<script lang="js">
  import Vue from "vue";
  export default {
    name: 'SavedSearchPage',
    props: [],
    mounted() {
      // gapi.signin2.render('google-signin-btn', { // this is the button "id"
      // onsuccess: this.onSignIn // note, no "()" here
      // })
      this.axios.get(process.env.VUE_APP_API_URL + 'api/search', {
          headers: {
            'Authorization': sessionStorage.getItem('profile_token')
          },
        })
        .then(response => {
          this.savedParameters = response.data.data;
          console.log(response);
  
        });
  
    },
    data() {
      return {
        savedParameters: [],
        defaultOpenedDetails: [1],
      }
    },
    methods: {
      deleteItem(element){
        this.axios.delete(process.env.VUE_APP_API_URL + 'api/search/'+element.id, {
          headers: {
            'Authorization': sessionStorage.getItem('profile_token')
          },
        })
        .then(response => {
            console.log(response);
            this.savedParameters = this.savedParameters.filter(item => item != element)
          this.$snackbar.open({
          position: 'is-top-right',
          message: 'La recherche a été supprimée',
          type: 'is-success',
        }) 
        
        }).catch((error) =>{
 this.$snackbar.open({
          position: 'is-top-right',
          message: 'Une erreur est survenue lors de la suppresion de la recherche',
          type: 'is-error',
        }) 
        
        });

      },
      getUrl(row) {
        return "/search?restore=" + row.id;
      },
    },
    computed: {
      userEmail(){
        return sessionStorage.getItem('email');
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1 {
    font-size: 30px;
  }
  
  .card {
    padding: 50px 0;
  }
  
  .space20 {
    display: block;
    height: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/SavedSearchPage.vue